import {styled} from "@mui/material/styles"
import {SimplifiedButton} from "../../../components"

export const StandardFacetListClearAllButton = styled(SimplifiedButton)`
    && {
        padding: 0;
        background-color: transparent;
        color: ${({theme}) => theme.colours.text.default};
        &:hover {
            background-color: ${({theme}) => theme.colours.form.input.background};
        }
        &:focus {
            background-color: ${({theme}) => theme.colours.form.input.background};
        }
    }
`
export default StandardFacetListClearAllButton
